import { render, staticRenderFns } from "./device-choices.vue?vue&type=template&id=0ffebd84&scoped=true"
import script from "./device-choices.vue?vue&type=script&lang=js"
export * from "./device-choices.vue?vue&type=script&lang=js"
import style0 from "./device-choices.vue?vue&type=style&index=0&id=0ffebd84&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffebd84",
  null
  
)

export default component.exports